import { deepMerge } from "./../../../_shared/deep-merge.js";
import { resolveDocumentColorToCss } from "./../../../_shared/theme-color-token.js";
function fixLineHeight(obj) {
  return {
    ...Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === "object" && value !== null ? fixLineHeight(value) : value
      ])
    ),
    ...obj.fontSize !== void 0 && obj.lineHeight === void 0 ? { lineHeight: 1.5 } : {}
  };
}
function toVars(customStyles, prefix = "", separator = "-") {
  const propertyNames = {};
  function traverseObject(currentObj, currentPath = "") {
    for (const [key, value] of Object.entries(currentObj)) {
      const fullPath = currentPath ? `${currentPath}${separator}${key}` : key;
      if (typeof value === "object") {
        traverseObject(value, fullPath);
      } else {
        const resolved = typeof value === "string" ? resolveDocumentColorToCss(value) ?? value : value;
        propertyNames[`${prefix ? prefix + "-" : ""}${fullPath}`] = resolved;
      }
    }
  }
  traverseObject(customStyles);
  return propertyNames;
}
const createCustomStyles = ({
  customStyles = {},
  settingsStyles = {},
  nativeStyle = {}
}) => {
  return deepMerge(
    {},
    toVars(fixLineHeight(customStyles), "custom"),
    toVars(settingsStyles, "settings"),
    toVars(nativeStyle, "native")
  );
};
export {
  createCustomStyles,
  fixLineHeight
};
//# sourceMappingURL=custom-styles.js.map
